/* Eya Clean Pro — Predictive Search API */

class PredictiveSearch {
  constructor() {
    this.input = document.querySelector("[data-predictive-search-input]");
    this.results = document.querySelector("[data-predictive-search-results]");
    this.timer = null;

    if (this.input && this.results) {
      this.input.addEventListener("input", () => this.onInput());
    }
  }

  onInput() {
    clearTimeout(this.timer);
    const query = this.input.value.trim();
    if (!query) {
      this.results.innerHTML = "";
      return;
    }

    this.timer = setTimeout(() => this.fetchResults(query), 250);
  }

  async fetchResults(query) {
    try {
      const res = await fetch("/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product,collection,page,article&resources[limit]=6");
      const data = await res.json();
      this.renderResults(data, query);
    } catch (err) {
      console.error(err);
    }
  }

  renderResults(data, query) {
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      this.results.innerHTML = "<p class=\"text-center\" style=\"padding: 2rem;\">No products found matching \"" + query + "\"</p>";
      return;
    }

    let html = "<div class=\"product-grid\" style=\"grid-template-columns: repeat(3, 1fr);\">";
    products.forEach(prod => {
      html += "<div class=\"product-card\" style=\"padding: 1rem;\">";
      html += "<a href=\"" + prod.url + "\">";
      html += "<img src=\"" + (prod.image || "") + "\" alt=\"" + prod.title + "\" style=\"aspect-ratio: 1/1; object-fit: contain; margin-bottom: 0.5rem;\">";
      html += "<h4 style=\"font-size: 0.95rem; font-weight: 600;\">" + prod.title + "</h4>";
      html += "<div style=\"font-weight: 700; color: var(--color-primary); margin-top: 0.25rem;\">SAR " + prod.price + "</div>";
      html += "</a></div>";
    });
    html += "</div>";
    this.results.innerHTML = html;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new PredictiveSearch();
});
